export const CROWD_PREDICTION_PARK_PATHS = new Set([
  '/',
  '/disney-adventure-world',
  '/parc-asterix',
  '/efteling',
  '/walibi-holland',
  '/europa-park',
  '/phantasialand',
  '/plopsaland-belgium',
  '/walibi-belgium',
  '/portaventura',
  '/gardaland',
  '/toverland',
  '/magic-kingdom',
  '/epcot',
  '/hollywood-studios',
  '/animal-kingdom',
  '/universal-studios',
  '/islands-of-adventure',
  '/epic-universe',
]);
